import "@eisinc/App/Libraries";
import "@eisinc/App/Store/Reducers";
import "@midpoint/XDL";

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// eslint-disable-next-line spire/fenced-imports
import { loadEditorTemplates } from "@insite/shell-public/EditorTemplatesLoader";

// this registers any custom editor templates that are used by custom pages/widgets
const templates = require.context("../../eisinc/src/App/EditorTemplates", true, /\.tsx$/);
const onHotTemplateReplace = loadEditorTemplates(templates);
if (module.hot) {
    module.hot.accept(templates.id.toString(), () => {
        onHotTemplateReplace(require.context("../../eisinc/src/App/EditorTemplates", true, /\.tsx$/));
    });
}

// load all widgets. Without this they won't be included in the bundle
const widgets = require.context("../../eisinc/src/App/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () =>
        onHotWidgetReplace(require.context("../../eisinc/src/App/Widgets", true, /\.tsx$/)),
    );
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("../../eisinc/src/App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(pages.id.toString(), () =>
        onHotPageReplace(require.context("../../eisinc/src/App/Pages", true, /\.tsx$/)),
    );
}

// load all handlers. They could be loaded individually instead.
const handlers = require.context("../../eisinc/src/App/Handlers", true); // Recursively get all handler modifications
handlers.keys().forEach(key => handlers(key)); // Load the handler modifications.

// load all widget extensions. They could be loaded individually instead
const widgetExtensions = require.context("../../eisinc/src/App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all widget extensions. They could be loaded individually instead
const componentExtensions = require.context("../../eisinc/src/App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

// load all page extensions. They could be loaded individually instead
const pageExtensions = require.context("../../eisinc/src/App/PageExtensions", true);
pageExtensions.keys().forEach(key => pageExtensions(key));

/**
 * Coveo Integration
 */
import "@eisinc/App/CoveoConnector/Store/Reducers";

// load all widgets. Without this they won't be included in the bundle
const coveoWidgets = require.context("../../eisinc/src/App/CoveoConnector/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onCoveoHotWidgetReplace = addWidgetsFromContext(coveoWidgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(coveoWidgets.id.toString(), () =>
        onCoveoHotWidgetReplace(require.context("../../eisinc/src/App/CoveoConnector/Widgets", true, /\.tsx$/)),
    );
}

const coveoHandlers = require.context("../../eisinc/src/App/CoveoConnector/Handlers", true);
coveoHandlers.keys().forEach(key => coveoHandlers(key));
/**
 * End Coveo Integration
 */
